<template>
  <div>
    <div v-if="selectedBot.jt_express_is_active" style="display: flex">
      <v-btn
        color="#FE0012"
        :loading="loadingJt || jtOrder.loading"
        depressed
        dark
        style="
          display: inline-block;
          margin-right: -5px;
          border-radius: 20px 0px 0px 0px !important;
        "
        @click.stop="dialogTypeShipping = true"
      >
        <v-icon class="mr-1">local_shipping</v-icon>{{ $t('send_by_jt') }}
      </v-btn>
      <v-menu offset-y>
        <template #activator="{ on }">
          <v-btn
            color="grey"
            class="ml-0"
            style="
              display: inline-block;
              border-radius: 0;
              background-color: #fe0012 !important;
              color: white !important;
              border-color: darkgray;
              border-radius: 0px 20px 20px 0px !important;
            "
            outline
            icon
            v-on="on"
          >
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="jtExpressPrintMobileLabel">
            <v-list-tile-title>{{ $t('print_label') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <v-dialog v-model="dialogTypeShipping" style="z-index: 210" persistent width="500">
      <v-card>
        <v-card-title class="mb-0 pb-0">
          <v-layout wrap>
            <v-flex
              ><h2 class="title my-2">{{ $t('choose_mode_of_transportation') }}</h2>
            </v-flex>
            <v-flex shrink class="text-xs-right">
              <v-btn flat fab small @click="dialogTypeShipping = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout></v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer"
                  @click="shipWithJt('pick_up')"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >local_shipping</v-icon
                      >

                      Pick up</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer"
                  @click="shipWithJt('drop_off')"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >inventory</v-icon
                      >
                      Drop off</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingJt" style="z-index: 210" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('please_wait') }}

          <v-progress-linear
            v-model="jtLoad"
            color="#FFFFFF"
            style="border-radius: 5px"
            class="text-xs-center"
            height="19"
          >
            <strong style="font-size: 14px; color: #fff">{{ jtLoad }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PDFMerger from 'pdf-merger-js/browser'
import { handleApiError } from '@/api/util'
import jAndTApi from '@/api/j-and-t.js'
export default {
  props: ['value', 'cbAll'],
  data: function () {
    return {
      dialogTypeShipping: false,
      summary: this.value,
      jtOrder: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      jtLoad: 0,
      loadingJt: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },

  methods: {
    async jtExpressPrintMobileLabel() {
      const vm = this
      vm.loadingJt = true
      let selected = vm.summary.filter((el) => {
        return vm.cbAll.includes(el.id) && el.jt_express_ref != null
      })
      if (selected.length == 0) {
        vm.$swal({
          title: vm.$t(
            vm.cbAll.length != 0 ? 'cant find order shipped by j&t' : 'choose ordered to print'
          ),
          type: 'error',
          confirmButtonText: vm.$t('Confirm'),
          showCancelButton: false,
          reverseButtons: true
        })

        vm.loadingJt = false
        return false
      }
      selected = selected.map((item) => item.id)
      const chunkSize = 100
      const ordersGroupId = []
      for (let i = 0; i <= selected.length; i += chunkSize) {
        const chunk = selected.slice(i, i + chunkSize)

        let response = await jAndTApi.postPrintOrder({
          data: {
            order_ids: chunk
          },
          pageid: vm.selectedBot.pageid
        })
        if (
          response.status == 200 &&
          response.data.result &&
          response.data.result.responseitems &&
          response.data.result.responseitems[0] &&
          response.data.result.responseitems[0].reportUrl
        ) {
          // ordersGroupId.push(response.result.responseitems[0].reportUrl)
          window.open(
            response.data.result.responseitems[0].reportUrl,
            `${response.data.result.responseitems[0].reportUrl}_blank`
          )
        } else if (
          ordersGroupId.length > 0 &&
          response.data &&
          response.data.data &&
          response.data.data.message == 'ORDER_DATA_NOT_FOUND'
        ) {
          ordersGroupId.push(null)
        } else {
          vm.$swal({
            title: vm.$t('Error'),
            type: 'error',
            text: response.data.message,
            confirmButtonText: vm.$t('Confirm')
          })
        }
      }
      if (ordersGroupId.length > 0) {
        const merger = new PDFMerger()
        for (const file of ordersGroupId) {
          if (file !== null) {
            await merger.add(file)
          }
        }

        const mergedPdf = await merger.saveAsBlob()

        const blob = new Blob([mergedPdf], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        window.open(link.href, '_blank')
      }
      vm.loadingJt = false
    },
    async shipWithJt(type) {
      const vm = this
      vm.dialogTypeShipping = false
      let selected = vm.summary.filter((el) => {
        return vm.cbAll.includes(el.id) && ['paid'].includes(el.status)
      })
      let notPass = []
      selected.map((item) => {
        item.shippingType ? `${item.shippingType}|${type}` : item.shippingType
        let address = item.nameaddress ? item.nameaddress.split(' , ') : null
        if (address.includes('')) {
          notPass.push(item.id)
        }
      })
      if (notPass.length > 0) {
        vm.$swal({
          title: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${notPass}`,
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else {
        selected = selected.map((item) => item.id)
        if (selected.length == 0) {
          await vm.$swal({
            title: vm.$t('send_with_jt_paid_only'),
            type: 'warning',
            confirmButtonText: vm.$t('Confirm')
          })
        } else {
          vm.createOrderJt(selected, type)
        }
      }
    },
    async createOrderJt(selected, type) {
      const vm = this
      try {
        vm.jtLoad = 0
        vm.loadingJt = true
        let response = await jAndTApi.postPostOrder({
          data: {
            order_ids: selected,
            type: type
          },
          pageid: vm.selectedBot.pageid
        })
        if (response.status == 200) {
          await vm.checkJtCreateOrder(selected)
          vm.jtOrder.show = true
          vm.jtOrder.status = 'PENDING'
          vm.jtOrder.interval = setInterval(async () => {
            let responseCreateOrder = await vm.checkJtCreateOrder(selected)
            if (vm.jtOrder.status == 'SUCCESS') {
              setTimeout(async () => {
                vm.loadingJt = false
                vm.dialogTypeShipping = false
                if (vm.jtOrder.interval) clearInterval(vm.jtOrder.interval)
                vm.$emit('onRefresh')
                await vm.$swal.fire({
                  title: vm.$t('Success'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
              }, 1000)
            } else if (vm.jtOrder.status == 'FAILED') {
              let dataFailed = ''
              let failed_answer = ''
              for (let i = 0; i < responseCreateOrder.order_data_failed.length; i++) {
                dataFailed += responseCreateOrder.order_data_failed[i].orderid
                failed_answer += responseCreateOrder.order_data_failed[i].status_message
                if (i < responseCreateOrder.order_data_failed.length - 1) {
                  dataFailed += ','
                  failed_answer += ','
                }
              }

              vm.loadingJt = false
              if (vm.jtOrder.interval) clearInterval(vm.jtOrder.interval)
              if (failed_answer == 'PLACE_ORDER_FAILED') {
                await vm.$swal.fire({
                  title: vm.$t('Error'),
                  html: `ไม่สามารถจัดส่งออเดอร์ ${dataFailed} ได้เนื่องจากข้อมูลไม่ถูกต้องกรุณากรอกข้อมูลให้ครบถ้วน`,
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
              } else {
                await vm.$swal.fire({
                  title: vm.$t('Error'),
                  html: `ไม่สามารถจัดส่งออเดอร์ ${dataFailed} ได้เนื่องจาก ${failed_answer}`,
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true,
                  preConfirm: () => vm.$emit('onRefresh')
                })
              }
            }
          }, 5000)
        } else {
          throw new Error('Response was not successful')
        }
      } catch (error) {
        let err = ''
        for (let i = 0; i < selected.length; i++) {
          err += selected[i]
          if (i < selected.length - 1) {
            err += ','
          }
        }
        if (error.response && error.response.data.message == 'INVALID_SHOP_ADDRESS') {
          const result = await vm.$swal.fire({
            title: vm.$t('กรุณาตั้งค่าที่อยู่ผู้ส่ง ก่อนทำการส่งกับ J&T Express'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
          if (result.value) {
            vm.$router.push('/' + vm.currentLang + `/template?tab=ShippingMethod`).catch(() => {})
          }
        } else if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await vm.$swal.fire({
            title: vm.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await vm.$swal.fire({
            title: `ไม่สามารถจัดส่งออเดอร์ต่อไปนี้ได้ ${err}`,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }

        vm.loadingJt = false
      }
    },
    async checkJtCreateOrder(selected) {
      const vm = this
      try {
        const config = {
          pageid: vm.selectedBot.pageid,
          data: {
            order_ids: selected
          }
        }
        let response = await jAndTApi.postCreateOrder(config)

        if (response.status == 200) {
          let data = response.data.result
          const totalOrder = data.total_order || 0
          const sumOrder = (data.total_success || 0) + (data.total_failed || 0)
          vm.jtLoad = totalOrder && sumOrder ? parseInt((sumOrder / totalOrder) * 100) : 0
          let isPending = data.order_data_pending.some((i) => i.status.includes('PENDING'))
          if (isPending) {
            vm.jtOrder.status = 'PENDING'
          } else {
            let isFailed = data.order_data_failed.some((i) => i.status.includes('FAILED'))
            if (isFailed) {
              vm.jtOrder.status = 'FAILED'
            } else {
              vm.jtOrder.status = 'SUCCESS'
            }
          }
        }
        return response.result
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingJt.vue